import React from 'react';
import Label from 'components/form/Label/Label';

const SesameGuarenteeDisclaimer = props => {
  const {
    title,
    description,
    subtitle,
    goToViewProgramTerms,
    className,
    color,
    labelClassName,
    titleClassName,
    descClassName,
    type,
  } = props;
  return (
    <Label className={labelClassName}>
      <span className={titleClassName}>{title}</span>
      <span>{description}</span>
      <span
        type={type}
        color={color}
        className={className}
        onClick={e => {
          e.stopPropagation();
          goToViewProgramTerms();
        }}
      >
        {subtitle}
      </span>
    </Label>
  );
};

export default SesameGuarenteeDisclaimer;
